import { render, staticRenderFns } from "./White808.vue?vue&type=template&id=67ffd9f8"
import script from "./White808.vue?vue&type=script&lang=js"
export * from "./White808.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports